import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import inboundApi from '../../../config/inboundApi';

const ROLES = [
  { value: 'admin', label: 'Admin', description: 'Full access to all settings and management features' },
  { value: 'agent', label: 'Agent', description: 'Can handle tickets and interact with customers' },
  { value: 'contributor', label: 'Contributor', description: 'Limited access, can view and add internal notes' },
];

export default function CreateStaffModal({ show, onClose }) {
  const [step, setStep] = useState(1);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('agent');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const reset = () => {
    setStep(1);
    setName('');
    setEmail('');
    setRole('agent');
    setError(null);
  };

  const handleClose = (saved) => {
    reset();
    onClose(saved);
  };

  const handleNext = () => {
    if (!name.trim() || !email.trim()) return;
    setStep(2);
  };

  const handleCreate = async () => {
    setSaving(true);
    setError(null);
    try {
      await inboundApi.post('/staff', { name: name.trim(), email: email.trim().toLowerCase(), role });
      handleClose('created');
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to create team member');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={() => handleClose(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>{step === 1 ? 'New Team Member' : 'Select Role'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        {step === 1 ? (
          <>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Full name"
                autoFocus
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@example.com"
                onKeyDown={(e) => e.key === 'Enter' && handleNext()}
              />
            </Form.Group>
          </>
        ) : (
          <div className="d-flex flex-column gap-2">
            {ROLES.map((r) => (
              <div
                key={r.value}
                onClick={() => setRole(r.value)}
                style={{
                  padding: '12px 16px',
                  border: `2px solid ${role === r.value ? '#0d6efd' : '#dee2e6'}`,
                  borderRadius: 8,
                  cursor: 'pointer',
                  backgroundColor: role === r.value ? '#f0f6ff' : '#fff',
                }}
              >
                <div style={{ fontWeight: 600 }}>{r.label}</div>
                <small className="text-muted">{r.description}</small>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        {step === 2 && (
          <Button variant="outline-secondary" onClick={() => setStep(1)}>
            Back
          </Button>
        )}
        <Button variant="secondary" onClick={() => handleClose(false)}>
          Cancel
        </Button>
        {step === 1 ? (
          <Button variant="primary" onClick={handleNext} disabled={!name.trim() || !email.trim()}>
            Next
          </Button>
        ) : (
          <Button variant="primary" onClick={handleCreate} disabled={saving}>
            {saving ? 'Creating...' : 'Create'}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
